import { CircleCheck, CircleLetterP, Clock } from "@gravity-ui/icons";
import { Icon, IconProps } from "@gravity-ui/uikit";
import classNames from "classnames";

import css from "../Stepper.module.scss";
import { StepItemProps, StepStatsEnum } from "../Stepper.types";
import { StepperItemContent } from "./StepperItemContent";

const statusToIcon: Record<StepStatsEnum, IconProps["data"]> = {
  [StepStatsEnum.Completed]: CircleCheck,
  [StepStatsEnum.InProgress]: Clock,
  [StepStatsEnum.Planned]: CircleLetterP,
};

export const StepperItem = (props: StepItemProps) => {
  const isCompleted = props.status === StepStatsEnum.Completed;
  const isPrevStepCompleted =
    props.prevStep?.status === StepStatsEnum.Completed;

  return (
    <li className={css.stepperItem}>
      <div className={css.stepperItemSeparator}>
        <div
          className={classNames(
            css.stepperItemIcon,
            isCompleted && css.stepperItemIconCompleted,
          )}
        >
          <Icon data={statusToIcon[props.status]} size={24} />
        </div>
        {props.stepIndex !== 0 && (
          <div
            className={classNames(
              css.stepperItemSeparatorLine,
              isCompleted &&
                isPrevStepCompleted &&
                css.stepperItemSeparatorLineCompleted,
            )}
          />
        )}
      </div>
      <StepperItemContent {...props} />
    </li>
  );
};
